import React, { useState } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonText,
  IonSpinner,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { tenantService } from '@/services/TenantService';
import { config } from '@/config/config';
import seeSorLogo from '@/assets/images/SeeSOR.png';

const SelectTenant: React.FC = () => {
  const [tenantCode, setTenantCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleConnect = async () => {
    const code = tenantCode.trim().toLowerCase();
    if (!code) {
      setError('Please enter your organization code.');
      return;
    }
    if (!config.tenants[code]) {
      setError('Organization not found. Please check the code and try again.');
      return;
    }
    setError('');
    setIsLoading(true);
    try {
      await tenantService.setTenant(code);
      history.push('/login');
    } catch {
      setError('Failed to connect. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.75rem 0' }}>
            <img src={seeSorLogo} alt="SeeSOR logo" style={{ width: '120px', height: 'auto' }} />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent
        fullscreen
        className="ion-padding"
        style={{ '--background': 'linear-gradient(135deg, #ffffff 0%, #4782aa 100%)' } as React.CSSProperties}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100%',
            padding: '20px',
          }}
        >
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '12px',
              padding: '2rem',
              width: '100%',
              maxWidth: '400px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            }}
          >
            <h2 style={{ textAlign: 'center', marginTop: 0, color: 'var(--ion-color-primary)' }}>
              Connect to your organization
            </h2>
            <p style={{ textAlign: 'center', color: 'var(--ion-color-medium)', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
              Enter the organization code provided by your administrator.
            </p>

            <IonItem lines="full">
              <IonLabel position="stacked">Organization Code</IonLabel>
              <IonInput
                value={tenantCode}
                onIonInput={(e) => setTenantCode(e.detail.value ?? '')}
                autocomplete="off"
                autocapitalize="none"
                onKeyDown={(e) => { if (e.key === 'Enter') void handleConnect(); }}
              />
            </IonItem>

            {error && (
              <IonText color="danger">
                <p style={{ fontSize: '0.875rem', margin: '0.5rem 1rem 0' }}>{error}</p>
              </IonText>
            )}

            <IonButton
              expand="block"
              onClick={() => void handleConnect()}
              disabled={isLoading}
              style={{ marginTop: '1.5rem' }}
            >
              {isLoading ? <IonSpinner name="crescent" /> : 'Connect'}
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SelectTenant;
